import { Box } from '@chakra-ui/react'

function MapContact({ bg2 }) {
    return (
        <Box bg={`url(${bg2})`} bgSize="cover" bgRepeat="no-repeat" width={'100%'} >
            <Box
                w={{ base: '100%', md: '80%', lg: '100%' }}
                h={{ base: '540px', md: '400px' }}
                borderRadius="xl"
                overflow="hidden"
                justifyContent={'center'}
                marginLeft={{ md: '10%', lg: '0' }}
            >
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3537.1049225152824!2d-99.506371!3d27.559254!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjfCsDMzJzMzLjMiTiA5OcKwMzAnMjIuOSJX!5e0!3m2!1ses-419!2smx!4v1765814873030!5m2!1ses-419!2smx"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                />
            </Box>
        </Box>
    )
}

export default MapContact